import * as Sentry from "@sentry/react";

import { Store } from '../../store/store';
import { StoreNode } from '../../store';
import { UserProfile } from '../../entities';

const SENTRY_DSN: string = import.meta.env?.VITE_SENTRY_DSN || '';
export class DiagnosticsService
  extends StoreNode {
  userProfile: UserProfile | undefined;

  constructor(store: Store) {
    super(store);

    // @ts-expect-error -- authService.context.profile is not exposed on the Store type but is accessible at runtime
    this.userProfile = store?.authService?.context?.profile
  }

  init() {
    const userProfile = this.userProfile
    const host = window.location?.hostname
    const nodeEnv = import.meta.env.MODE

    try {
      Sentry.init({
        dsn: SENTRY_DSN,
        // Preserve v10 collection defaults; v11 otherwise collects more data.
        dataCollection: {
          userInfo: false,
          cookies: false,
          httpHeaders: {
            request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
            response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
          },
          httpBodies: [],
          urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
          genAI: { inputs: false, outputs: false },
          databaseQueryData: false,
          queues: false,
          graphQL: { document: false, variables: false },
          frameContextLines: 7,
        },
        attachStacktrace: false,
        // shortcut: keep transaction dashboards compatible until they support streamed spans.
        traceLifecycle: 'static',
        integrations: [
          Sentry.browserTracingIntegration({
            webVitals: { softNavigations: false, bfcacheNavigations: false },
          }),
          Sentry.browserSessionIntegration({ lifecycle: 'route' }),
          Sentry.userTimingIntegration(),
          Sentry.captureConsoleIntegration({
            levels: ['warn', 'error', 'assert']
          })
        ],
        environment: host,
        tracesSampleRate: 0.1,
        beforeSend(event: Sentry.ErrorEvent) {
          if (userProfile) {
            event.user = { 
              email: userProfile?.email
            }
          }

          return event;
        },
      });

      Sentry.setTag("node_env", nodeEnv);
    } catch(e) {
      console.error(e);
    }
  }

  captureException(err: unknown) {
    try {
      return Sentry.captureException(err);
    } catch(e) {
      console.error(e);
    }
  }
}
